import React from "react";
import { FastField, Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AppInput from "../../../components/Input/AppInput";
import { Box, Button, FormGroup, InputAdornment } from "@material-ui/core";
import { Lock, Mail } from "@material-ui/icons";
import AppCheckbox from "../../../components/Input/AppCheckbox";
import AppButton from "../../../components/CustomButtons/AppButton";
import AppColor from "utilities/AppColor";
// import { YupValidations } from "utils/validate";
import AppConfig from "config/AppConfig";
const { PATTERNS } = AppConfig;

const AdminLoginForm = (props) => {
  const {
    onSubmit,
    loading,
    navigateToForgotPassword,
    isNavigateforgotPassword,
    emailLogin
  } = props;
  const { t } = useTranslation();
  return (
    <Formik
      onSubmit={(data) => onSubmit({
        ...data
      })}
      enableReinitialize
      initialValues={{
        email: emailLogin && emailLogin !== ''
        ? emailLogin
        : (process.env.NODE_ENV === "development" ? "admin@care-aid.com" : ""),
        password: process.env.NODE_ENV === "development" ? "@Abc123456" : "",
        keepMeLogin: false
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string().trim()
        .required('validation.email.required')
        .email('validation.email.invalid')
        .max(255, { message: 'validation.max_length', value: 255})
        .matches(PATTERNS.BLANK_SPACES, 'validation.blankSpaces'),
        password: Yup.string().required('validation.password.required'),
        keepMeLogin: Yup.bool()
      })}
    >
      {({ handleSubmit }) => {
        return (
          <Form>
            <FastField
              component={AppInput}
              name="email"
              id="email"
              label={t("label.email")}
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Mail />
                  </InputAdornment>
                ),
                onKeyDown: (event) => event.key === "Enter" && handleSubmit(),
              }}
            />
            <FastField
              component={AppInput}
              name="password"
              id="password"
              label={t("label.password")}
              type="password"
              noMultiline
              required
              InputProps={{
                type: "password",
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
                onKeyDown: (event) => event.key === "Enter" && handleSubmit(),
              }}
            />
            <FastField
              component={AppCheckbox}
              name="keepMeLogin"
              id="keepMeLogin"
              label={t("label.keep_me_login")}
            />
            <FormGroup>
              <Box display="flex" justifyContent="flex-end">
                <AppButton
                  onClick={handleSubmit}
                  label={t('label.login')}
                  type="submit"
                  isLoading={loading}
                  disabled={loading}
                />
              </Box>
              {isNavigateforgotPassword && <Button
                onClick={navigateToForgotPassword}
                style={{
                  textTransform: "unset",
                  fontWeight: '600',
                  color: AppColor.mainColor
                }}
              >
                {t('button.forgotPassword')}?
              </Button>}
            </FormGroup>
          </Form>
        );
      }}
    </Formik>
  );
};

AdminLoginForm.propTypes = {
  onSubmit: PropTypes.func,
  navigateToForgotPassword: PropTypes.func,
  loading: PropTypes.bool,
  isNavigateforgotPassword: PropTypes.bool,
  emailLogin: PropTypes.string
};

export default AdminLoginForm;
